import { useState, useEffect } from 'react'
import EventCard from '../components/EventCard'

export default function Events() {
  const [selectedCategory, setSelectedCategory] = useState('All')

  useEffect(() => {
    document.title = 'Events - KALARAVA 4.0'
  }, [])

  const events = [
    {
      name: 'General Quiz',
      description: 'Test your knowledge on general knowledge and current affairs',
      category: 'Literary',
      rules: [
        'Individual participation.',
        'Quiz on general knowledge and current affairs',
        'Round 1- MCQ (Multiple choice questions)',
        'Round 2- Identifying Pictures',
        'Round 3- Question answer and Rapid Fire.',
      ],
      criteria: [
        'Accuracy of answers',
        'Speed of response',
        'Overall score',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'IT Quiz for CS Students',
      description: 'Quiz on IT Industry and IT current affairs',
      category: 'Tech',
      rules: [
        'Individual participation.',
        'Quiz on IT Industry and IT current affairs',
        'Round 1- MCQ (Multiple choice questions)',
        'Round 2- Identifying Pictures',
        'Round 3- Question answer and Rapid Fire.',
      ],
      criteria: [
        'Accuracy of answers',
        'Speed of response',
        'Overall score',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Photography',
      description: 'Capture moments based on given theme',
      category: 'Media',
      rules: [
        'Individual participation.',
        'Theme will be given on spot',
        'Students can bring their camera or mobile phone camera is allowed.',
        'Click the photos based on the theme given then submit best 3 photos of your choice within the specified time.',
        'Time duration will inform you on the event day.',
      ],
      criteria: [
        'Composition and framing',
        'Creativity and originality',
        'Technical quality',
        'Theme relevance',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Solo Dance',
      description: 'Traditional/Folk/Classical/Filmy dance performance',
      category: 'Cultural',
      rules: [
        'Solo Dance theme is- Traditional/Folk/Classical/ filmy (choose the song which should not have vulgar content and should not promote any kind of vulgarity).',
        'Time duration- 5 to 6 min',
        'Song should be submitted before the competition starts.',
        'Judgment is based on costume used, song selection, and performance',
      ],
      criteria: [
        'Costume used',
        'Song selection',
        'Performance quality',
        'Stage presence',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Group Dance',
      description: 'Group dance performance with 4-8 members',
      category: 'Cultural',
      rules: [
        'Maximum 4 - 8 members in a team',
        'Group Dance theme is- Traditional/Folk/Classical/filmy (choose the song which should not have vulgar content and should not promote any kind of vulgarity).',
        'Time duration- 5 to 6 min',
        'Song should be submitted before the competition starts.',
        'Judgment is based on costume used, song selection, team coordination and performance.',
      ],
      criteria: [
        'Costume used',
        'Song selection',
        'Team coordination',
        'Performance quality',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Mehandi',
      description: 'Henna art with Bridal/Dulhan theme',
      category: 'Art',
      rules: [
        'Can participate solo or with a model',
        'Theme is Bridal/Dulhan Mehendi',
        'Time duration is 2 hours.',
        'No premade stickers, carbon papers.',
      ],
      criteria: [
        'Design complexity',
        'Precision and neatness',
        'Creativity',
        'Finish quality',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Reels',
      description: 'Create engaging short videos on given topic',
      category: 'Media',
      rules: [
        'Maximum two member in a team.',
        'Topic will be given on the spot.',
      ],
      criteria: [
        'Creativity and originality',
        'Video quality and editing',
        'Engagement factor',
        'Message clarity',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Speech',
      description: 'Showcase your speaking skills on given topics',
      category: 'Literary',
      rules: [
        'Individual participation.',
        'Time duration is 8 to 10 min.',
        'Speech can be in Kannada or Hindi or English.',
        'Offensive or inappropriate words are not allowed, if used will lead to disqualification',
        'Speech Topics are- Role of farmers, Value of hardwork, Pros and cons of online learning',
      ],
      criteria: [
        'Content quality',
        'Delivery and fluency',
        'Confidence and clarity',
        'Audience engagement',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Gaming - BGMI',
      description: 'Battle Ground Mobile India tournament',
      category: 'Gaming',
      rules: [
        'Individual participation.',
        'Install the Mobile Game- BGMI(Battle Ground Mobile India)',
        'Participant mobile should have fully charged,proper internet connectivity.',
        'Based on the number participants the rounds will be decided.',
      ],
      criteria: [
        'Rank achieved',
        'Kills and assists',
        'Survival time',
        'Overall performance',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Gaming - Free Fire',
      description: 'Free Fire mobile game tournament',
      category: 'Gaming',
      rules: [
        'Individual participation.',
        'Install the Mobile Game- Free-Fire',
        'Participant mobile should have fully charged,proper internet connectivity.',
        'Based on the number participants the rounds will be decided.',
      ],
      criteria: [
        'Rank achieved',
        'Kills and assists',
        'Survival time',
        'Overall performance',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Rangoli',
      description: 'Traditional colorful floor art on given theme',
      category: 'Art',
      rules: [
        'Individual participation.',
        'Theme will be given on the spot.',
        'Participant has to bring the required colors of rangoli.',
        'Time duration is 2 hours.',
      ],
      criteria: [
        'Design and creativity',
        'Color coordination',
        'Precision and detail',
        'Theme relevance',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Pencil Sketch',
      description: 'Create beautiful pencil artwork on given theme',
      category: 'Art',
      rules: [
        'Individual participation.',
        'Theme will be given on the spot.',
        'Participant has to bring the sheet and pencil.',
        'Time duration is 2 hours.',
      ],
      criteria: [
        'Technical skill',
        'Shading and detail',
        'Composition',
        'Creativity',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Singing',
      description: 'Vocal performance showcase',
      category: 'Cultural',
      rules: [
        'Individual participation.',
        'Theme will be given on the spot.',
        'Duration of performance: 2 to 3 minutes. Exceeding the time may lead to a deduction in marks',
        'Cinema songs are allowed.',
        'Singers may use a Karaoke track or Instruments.',
        'Follow the uploaded guidelines to share the performance video.',
        'Use of vulgar, sexually explicit, violent language and/or lyrics is strictly prohibited.',
        'The participant may submit only one song with registration (per person). The category for the song has to be selected at the time of registration.',
        'Judgment is on the qualities like Swara, Taal and selection of song, composition and overall impression.',
        'The contestant should be dressed appropriately during the Performance. Indecent exposure is NOT allowed.',
      ],
      criteria: [
        'Vocal quality and pitch',
        'Swara, Taal and song selection',
        'Composition and overall impression',
        'Stage presence and dress',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Coding for CS Students',
      description: 'Programming competition with MCQ and debugging',
      category: 'Tech',
      rules: [
        'Individual participation.',
        'First Round MCQ on C++.',
        '2nd Round Debugging (C++ Programming)',
        'Total Time duration for 1st and 2nd round is 2 hours(1 hour each round).',
      ],
      criteria: [
        'Number of problems solved',
        'Code efficiency',
        'Time taken',
        'Correctness of solution',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Essay Writing',
      description: 'Write compelling essays on given topic',
      category: 'Literary',
      rules: [
        'Individual participation.',
        'Time duration 1 hour.',
        'Topic will be given on the spot.',
        'Students can write essay in Kannada,Hindi,English.',
      ],
      criteria: [
        'Content and ideas',
        'Grammar and vocabulary',
        'Structure and organization',
        'Originality',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Ad Mad Show',
      description: 'Funny ads and comedy sketches on given product/theme',
      category: 'Cultural',
      rules: [
        'Each team must have 2–5 members.',
        'Performance time limit: 2–3 minutes.',
        'Product/theme will be given on the spot.',
        'Teams may copy or recreate existing ads.',
        'Use of safe props only; no dangerous items allowed.',
        'No vulgar, abusive, or offensive content.',
        'Time limit must be strictly followed.',
        'All team members must participate.',
        'Judges\' decision will be final.',
      ],
      criteria: [
        'Humor and entertainment value',
        'Creativity and originality',
        'Stage presence',
        'Team coordination',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Water Painting',
      description: 'Watercolor art competition on given theme',
      category: 'Art',
      rules: [
        'Individual participation.',
        'Time duration 1 hour.',
        'Topic will be given on the spot.',
      ],
      criteria: [
        'Color harmony',
        'Technique and blending',
        'Composition',
        'Originality',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Treasure Hunt',
      description: 'Solve clues and find hidden treasures',
      category: 'Cultural',
      rules: [
        'Teams must stay together at all times.',
        'Clues will be given one by one—don\'t damage or hide them.',
        'No cheating, no teaming with others, and no phones',
        'Stay within the allowed area; don\'t disturb classes or restricted places.',
        'First team to solve all clues and reach the treasure wins.',
        'Any misconduct or rule-breaking leads to disqualification.',
        'Organizers\' decision is final.',
      ],
      criteria: [
        'Speed of completion',
        'Accuracy in solving clues',
        'Team coordination',
        'Rule adherence',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
    {
      name: 'Best Out of Waste',
      description: 'Create art from recycled/waste materials',
      category: 'Art',
      rules: [
        'Individual participation.',
        'Time duration 2 hour.',
        'Participants have to bring their own materials',
      ],
      criteria: [
        'Creativity and innovation',
        'Use of materials',
        'Aesthetic appeal',
        'Message/concept clarity',
      ],
      registerLink: 'https://forms.gle/KLEF3S1Ve5d5S9fv6',
    },
  ]

  const categories = ['All', 'Cultural', 'Art', 'Media', 'Literary', 'Tech', 'Gaming']

  const filteredEvents = selectedCategory === 'All'
    ? events
    : events.filter(event => event.category === selectedCategory)

  return (
    <>
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 animate-fade-up">
            <div className="inline-block mb-4">
              <h1 className="text-5xl md:text-6xl font-black bg-gradient-to-r from-kala-orange via-kala-yellow to-kala-cyan bg-clip-text text-transparent mb-4">
                🎉 Events 🎉
              </h1>
            </div>
            <p className="text-xl text-kala-secondary font-semibold">
              18 exciting competitions across multiple categories
            </p>
            <div className="h-1 w-24 mx-auto mt-4 rounded-full" style={{
              background: 'linear-gradient(90deg, #FF7B3D, #FFD84D, #37E7D9, #2FA8FF)'
            }}></div>
          </div>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3 mb-12 animate-fade-up" style={{ animationDelay: '0.1s' }}>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                  selectedCategory === category
                    ? 'bg-gradient-to-r from-kala-blue to-kala-cyan text-white shadow-soft-lg'
                    : 'bg-kala-card text-kala-secondary border border-kala-border hover:border-kala-blue'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Events Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 animate-fade-up" style={{ animationDelay: '0.2s' }}>
            {filteredEvents.map((event, idx) => (
              <div key={idx} style={{ animationDelay: `${0.2 + idx * 0.05}s` }} className="animate-fade-up">
                <EventCard event={event} />
              </div>
            ))}
          </div>

          {/* No Events Message */}
          {filteredEvents.length === 0 && (
            <div className="text-center py-12">
              <p className="text-kala-secondary text-lg">No events found in this category.</p>
            </div>
          )}
        </div>
      </section>
    </>
  )
}

